import { strCol, numCol, intCol } from '@integec/grid-tools'
import { utilityHeader, unitIdHeader } from 'core/HeaderColTypeProps'

export const headers = [
  utilityHeader,
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    width: 70,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    width: 70,
  }),
  strCol({
    ident: 'revCode',
    display: 'Rev Code',
  }),
  strCol({
    ident: 'pFuel',
    display: 'Primary Fuel',
  }),
  numCol({
    ident: 'pBurned',
    display: 'Primary Fuel Burned',
  }),
  numCol({
    ident: 'pAvgHeat',
    display: 'Primary Avg Heat',
  }),
  numCol({
    ident: 'pAsh',
    display: 'Primary Ash Content',
  }),
  numCol({
    ident: 'pMoist',
    display: 'Primary Moisture Content',
  }),
  numCol({
    ident: 'pSulfur',
    display: 'Primary Sulfur Content',
  }),
  strCol({
    ident: 'sFuel',
    display: 'Secondary Fuel',
  }),
  numCol({
    ident: 'sBurned',
    display: 'Secondary Fuel Burned',
  }),
  numCol({
    ident: 'sAvgHeat',
    display: 'Secondary Avg Heat',
  }),
  numCol({
    ident: 'sAsh',
    display: 'Secondary Ash Content',
  }),
  numCol({
    ident: 'sMoist',
    display: 'Secondary Moisture Content',
  }),
  numCol({
    ident: 'sSulfur',
    display: 'Secondary Sulfur Content',
  }),
  strCol({
    ident: 'tFuel',
    display: 'Tertiary Fuel',
  }),
  numCol({
    ident: 'tBurned',
    display: 'Tertiary Fuel Burned',
  }),
  numCol({
    ident: 'tAvgHeat',
    display: 'Tertiary Avg Heat',
  }),
  numCol({
    ident: 'tAsh',
    display: 'Tertiary Ash Content',
  }),
  numCol({
    ident: 'tMoist',
    display: 'Tertiary Moisture Content',
  }),
  numCol({
    ident: 'tSulfur',
    display: 'Tertiary Sulfur Content',
  }),
  strCol({
    ident: 'qFuel',
    display: 'Quaternary Fuel',
  }),
  numCol({
    ident: 'qBurned',
    display: 'Quaternary Fuel Burned',
  }),
  numCol({
    ident: 'qAvgHeat',
    display: 'Quaternary Avg Heat',
  }),
  numCol({
    ident: 'qAsh',
    display: 'Quaternary Ash Content',
  }),
  numCol({
    ident: 'qMoist',
    display: 'Quaternary Moisture Content',
  }),
  numCol({
    ident: 'qSulfur',
    display: 'Quaternary Sulfur Content',
  }),
  strCol({
    ident: 'line',
    display: 'Line',
  }),
  strCol({
    ident: 'lockReleased',
    display: 'Lock Released',
  }),
]

export const title = 'Card 99'

const readOnlyCols = ['utility', 'unit', 'year', 'month']

export const isEditable = ({ header }) => !readOnlyCols.includes(header.ident)
